import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';

@Component({
  selector: 'app-order-note-header',
  templateUrl: './order-note-header.component.html',
  styleUrls: ['./order-note-header.component.css']
})
export class OrderNoteHeaderComponent implements OnInit {
  @Input() orderactivetab = 1;
  @Output() tabClicked = new EventEmitter<string>();
  private _openedDocuments: boolean = false;
  private _openedAlerts: boolean = false;
  isSilderbarAlert: boolean = false;
  isSilderbarDocuments: boolean = false;
  constructor(private route: ActivatedRoute,
    private router: Router, private bannerService: PatientBannerService) {
    localStorage.setItem("ordernoteheaderVisibility", "True");
    sessionStorage.removeItem("AlertsheaderIconVisibility");
    sessionStorage.removeItem("rxfromsearch");
    CommonComponents.ordernoteheaderVisibility = true;
    CommonComponents.headerVisibility = false;

  }

  ngOnInit() {

  }

  onLinkClick(event: MatTabChangeEvent) {

    event.tab.isActive = true;
    if (event.tab.textLabel == 'Rx') {
      this.tabClicked.emit('/Rx?fromOrderNote=true');
    }
    else
      this.tabClicked.emit(event.tab.textLabel.replace(" ", ""));
    // this.router.navigateByUrl('/OrderNote/'+event.tab.textLabel.replace(" ", "")); 
  }
  onClickCancel() {
    sessionStorage.removeItem("patientId");
    sessionStorage.removeItem("patientName");
    localStorage.removeItem("isBackBtnVisibleInVisitNotes");
    var displayDate = sessionStorage.getItem("displayappDate");
    sessionStorage.setItem("displayDate", displayDate);
    CommonComponents.patientId = 0;
    CommonComponents.patientName = '';
    this.bannerService.toggle(Number("-1"));
    this.router.navigate(["Appointments"]);
  }

  public _AlertSidebar(event) {
    this._openedAlerts = !this._openedAlerts
    this.isSilderbarDocuments = false;
    this.isSilderbarAlert = !this.isSilderbarAlert;
    this._openedDocuments = false;
    sessionStorage.setItem("visitNoteAlertsheaderVisibility", "false");
    sessionStorage.setItem("AlertsheaderIconVisibility", "true");
  }
  closeAlerts() {
    this._openedAlerts = !this._openedAlerts;
    this.isSilderbarAlert = false;

  }
  Isdocument: boolean = false;
  public DocumentsSidebar(event) {
    // this._opened = !this._opened;
    sessionStorage.setItem("fromscreen", "visitdocument");
    this._openedDocuments = !this._openedDocuments;
    this.isSilderbarAlert = false;
    this.isSilderbarDocuments = true;
    this._openedAlerts = false;
    sessionStorage.setItem("hideDocumentsHeader", "true");
    this.Isdocument = true;
  }
  closeDocuments() {
    this._openedDocuments = false;
    this.Isdocument = false;
  }
}
